import React,{useContext} from 'react';

import { ThemeContext } from '../../contexts/ThemeContext';

import { servicesData } from '../../data/servicesData';

import './Services.css'
import SingleService from './SingleService/SingleService';

function Services(props) {

    const { theme } = useContext(ThemeContext);
    return (
        <>
            {servicesData.length > 0 && (
                <div className="services" id="services" style={{backgroundColor:theme.secondary}}>
                    <div className="services-header">
                        <h1 style={{color: theme.primary}}>Services</h1>
                    </div>
                    <div className="services-body">
                        <p style={{color:theme.tertiary80}}>
                            <div dangerouslySetInnerHTML={{ __html: props.description }} />
                        </p>
                        <div className="services-bodycontainer">
                            {props.services.map(service => (
                                <SingleService
                                key={service.id}
                                id={service.id}
                                title={service.Titre}
                              />
                            ))}
                        </div>
                    </div>
                </div>
            )}
       </>
    )
}

export default Services
